import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const EVENT_TYPES = [{
  name: 'Birthdays',
  slug: 'birthdays',
  image: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?q=80&w=2070&auto=format&fit=crop'
}, {
  name: 'Baby Showers',
  slug: 'baby-showers',
  image: 'https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=2070&auto=format&fit=crop'
}, {
  name: 'Bridal Showers',
  slug: 'bridal-showers',
  image: 'https://images.unsplash.com/photo-1523292562811-8fa7962a78c8?q=80&w=2070&auto=format&fit=crop'
}, {
  name: 'Weddings & Receptions',
  slug: 'weddings-receptions',
  image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=2069&auto=format&fit=crop'
}, {
  name: 'Graduations',
  slug: 'graduations',
  image: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?q=80&w=2070&auto=format&fit=crop'
}, {
  name: 'Corporate Events',
  slug: 'corporate-events',
  image: 'https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=2069&auto=format&fit=crop'
}, {
  name: 'Private Dinners',
  slug: 'private-dinners',
  image: 'https://images.unsplash.com/photo-1559339352-11d035aa65de?q=80&w=1974&auto=format&fit=crop'
}, {
  name: 'Vendor Events & Pop-Ups',
  slug: 'vendor-events-pop-ups',
  image: 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?q=80&w=2070&auto=format&fit=crop'
}];
export function FeaturedEvents() {
  return <section className="py-24 bg-gray-50" data-id="element-19">
      <div className="mx-4 md:mx-[4.1rem]" data-id="element-20">
        <div className="max-w-[1440px] mx-auto px-6" data-id="element-21">
          <div className="text-center mb-16" data-id="element-22">
            <span className="text-[12px] uppercase tracking-[0.3em] font-bold text-[#b22222] mb-4 block" data-id="element-23">
              Our Expertise
            </span>
            <h2 className="font-serif text-4xl md:text-5xl text-gray-900" data-id="element-24">
              Featured Events
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-25">
            {EVENT_TYPES.map((event, index) => <Link key={event.name} to={`/events/${event.slug}`} data-id="element-26">
                <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="group relative h-[200px] overflow-hidden cursor-pointer" data-id="element-27">
                  <img src={event.image} alt={event.name} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" data-id="element-28" />
                  <div className="absolute inset-0 bg-black/30 group-hover:bg-black/50 transition-colors duration-500" data-id="element-29" />
                  <div className="absolute inset-0 flex items-center justify-center p-6" data-id="element-30">
                    <div className="text-center" data-id="element-31">
                      <h3 className="text-white font-serif text-2xl md:text-3xl mb-4 translate-y-2 group-hover:translate-y-0 transition-transform duration-500" data-id="element-32">
                        {event.name}
                      </h3>
                      <div className="w-0 h-[1px] bg-white group-hover:w-full transition-all duration-500 mx-auto" data-id="element-33" />
                    </div>
                  </div>
                </motion.div>
              </Link>)}
          </div>
        </div>
      </div>
    </section>;
}